import type { ComponentType } from "react";
import Layout from "@/components/layout";
import SeoHead from "@/components/seo-head";

export default function PersonaStaticRoute({
  siteData,
  Landing,
  title,
  description,
  ...props
}: {
  siteData: any;
  Landing: ComponentType<any>;
  title: string;
  description: string;
  [key: string]: any;
}) {
  return (
    <>
      <SeoHead meta={{ title, description, canonicalPath: typeof props.entry?.fields?.url === "string" ? `${props.entry.fields.url.replace(/\/$/, "")}/` : undefined }} />
      <Layout siteData={siteData}>
        <Landing {...props} siteData={siteData} />
      </Layout>
    </>
  );
}
